import React from 'react';
import { CurrencyRate } from '../services/mcpClient';

interface CurrencyRatesProps {
  currencyRate: CurrencyRate | null;
  loading: boolean;
  error: string | null;
}

const CurrencyRates: React.FC<CurrencyRatesProps> = ({ currencyRate, loading, error }) => {
  if (loading) {
    return (
      <div className="currency-rates">
        <h3>💱 Currency Exchange</h3>
        <div className="loading">Loading currency rates...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="currency-rates">
        <h3>💱 Currency Exchange</h3>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  if (!currencyRate) {
    return (
      <div className="currency-rates">
        <h3>💱 Currency Exchange</h3>
        <div className="no-data">No currency data available</div>
      </div>
    );
  }

  return (
    <div className="currency-rates">
      <h3>💱 Currency Exchange</h3>
      <div className="currency-card">
        <div className="currency-header">
          <h4>{currencyRate.name}</h4>
          <span className="currency-pair">
            {currencyRate.fromCurrency} → {currencyRate.toCurrency}
          </span>
        </div>
        <div className="currency-rate">
          {currencyRate.rate !== null ? currencyRate.rate.toFixed(4) : 'N/A'}
        </div>
        <div className={`currency-change ${(currencyRate.changePercent || 0) >= 0 ? 'positive' : 'negative'}`}>
          {currencyRate.change !== null && currencyRate.changePercent !== null ? (
            <>
              {currencyRate.change >= 0 ? '+' : ''}{currencyRate.change.toFixed(4)} 
              ({currencyRate.changePercent >= 0 ? '+' : ''}{currencyRate.changePercent.toFixed(2)}%)
            </>
          ) : 'N/A'}
        </div>
        <div className="currency-details">
          <div className="detail-item">
            <span className="label">Previous Close:</span>
            <span className="value">
              {currencyRate.previousClose !== null ? currencyRate.previousClose.toFixed(4) : 'N/A'}
            </span>
          </div>
          <div className="detail-item">
            <span className="label">Day High:</span>
            <span className="value">
              {currencyRate.dayHigh !== null ? currencyRate.dayHigh.toFixed(4) : 'N/A'}
            </span>
          </div>
          <div className="detail-item">
            <span className="label">Day Low:</span>
            <span className="value">
              {currencyRate.dayLow !== null ? currencyRate.dayLow.toFixed(4) : 'N/A'}
            </span>
          </div>
          <div className="detail-item">
            <span className="label">Market State:</span>
            <span className="value">{currencyRate.marketState}</span>
          </div>
          <div className="detail-item">
            <span className="label">Last Update:</span>
            <span className="value">
              {new Date(currencyRate.lastUpdate).toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyRates;

